import { Link } from "react-router-dom";
import { ArrowLeft, ShieldCheck } from "lucide-react";

const Section = ({ title, children }) => (
  <div className="mb-8">
    <h2 className="font-heading font-semibold text-lg text-slate-900 mb-3">{title}</h2>
    <div className="text-sm text-slate-600 leading-relaxed space-y-3">{children}</div>
  </div>
);

export default function Privacidade() {
  return (
    <main data-testid="privacy-page" className="bg-[#F7F9FC] min-h-screen px-4 sm:px-6 lg:px-8 py-16 text-left">
      <div className="max-w-3xl mx-auto">
        <Link to="/" data-testid="privacy-back-link" className="inline-flex items-center gap-2 text-sm text-slate-600 hover:text-[#2E9FDB] transition-colors mb-10">
          <ArrowLeft className="w-4 h-4" /> Voltar à página inicial
        </Link>

        <div className="flex items-center gap-2 mb-2">
          <ShieldCheck className="w-5 h-5 text-[#2E9FDB]" />
          <p className="font-mono-brand text-xs tracking-[0.25em] uppercase text-[#2E9FDB]">LGPD</p>
        </div>
        <h1 className="font-heading font-bold text-3xl sm:text-4xl text-slate-900 mb-3">Política de Privacidade</h1>
        <p className="text-xs text-slate-500 mb-10">Última atualização: junho de 2026 · despachantesdetran.com.br</p>

        <Section title="1. Quem somos">
          <p>
            O despachantesdetran.com.br é uma iniciativa privada de encaminhamento de solicitações
            relacionadas a serviços de documentação de veículos a despachantes e profissionais
            independentes qualificados. Não somos o DETRAN e não possuímos qualquer vínculo com
            órgãos públicos.
          </p>
        </Section>

        <Section title="2. Dados coletados">
          <p>Ao preencher o formulário de solicitação de atendimento, coletamos apenas os dados necessários para o atendimento:</p>
          <ul className="list-disc pl-5 space-y-1">
            <li>Estado (UF) e cidade;</li>
            <li>Serviço desejado;</li>
            <li>Nome;</li>
            <li>Número de WhatsApp;</li>
            <li>Endereço de e-mail.</li>
          </ul>
        </Section>

        <Section title="3. Finalidade do uso dos dados">
          <p>
            Os dados fornecidos são utilizados exclusivamente para identificar o profissional mais
            adequado à sua demanda e viabilizar o contato para atendimento da solicitação
            realizada. O tratamento tem como base legal o consentimento do titular (art. 7º, I, da
            Lei nº 13.709/2018 — LGPD), manifestado por meio da marcação da caixa de autorização no
            formulário.
          </p>
        </Section>

        <Section title="4. Compartilhamento">
          <p>
            Seus dados poderão ser compartilhados unicamente com o profissional responsável pelo
            atendimento da sua solicitação. Não vendemos, alugamos ou compartilhamos seus dados com
            terceiros para fins de marketing.
          </p>
        </Section>

        <Section title="5. Armazenamento e segurança">
          <p>
            Os dados são armazenados em ambiente seguro e mantidos apenas pelo período necessário ao
            atendimento da solicitação e ao cumprimento de obrigações legais.
          </p>
        </Section>

        <Section title="6. Seus direitos">
          <p>
            Nos termos da LGPD, você pode solicitar, a qualquer momento, a confirmação do
            tratamento, o acesso, a correção, a anonimização ou a exclusão dos seus dados, bem como
            a revogação do consentimento. Para exercer seus direitos, utilize os canais de contato
            disponibilizados durante o seu atendimento.
          </p>
        </Section>

        <Section title="7. Alterações desta política">
          <p>
            Esta política poderá ser atualizada periodicamente. A versão vigente estará sempre
            disponível nesta página.
          </p>
        </Section>

        <Link
          to="/#solicitar"
          data-testid="privacy-cta"
          className="btn-cta inline-block bg-[#2E9FDB] text-[#06305F] font-heading font-bold text-sm px-8 py-3.5 rounded-full uppercase tracking-wide mt-4"
        >
          Solicitar atendimento
        </Link>
      </div>
    </main>
  );
}
